interface Props {
  text: string;
  /** Use compact styling (12px, muted body) for embedded panels. Default: 14px, navy. */
  compact?: boolean;
}

interface AvatarProps {
  size?: number;
  style?: React.CSSProperties;
}

export function AgentAvatar({ size = 32, style }: AvatarProps) {
  const s = size;
  return (
    <img
      src="/brand/etna-avatar.jpg"
      alt="Ethische Etna"
      style={{
        width: `${s}px`,
        height: `${s}px`,
        borderRadius: "50%",
        objectFit: "cover",
        flexShrink: 0,
        ...style,
      }}
    />
  );
}

export function AgentMessageText({ text, compact = false }: Props) {
  const segments = text.split(/\*\*(.*?)\*\*/g);
  return (
    <div
      style={{
        whiteSpace: "pre-line",
        lineHeight: compact ? 1.6 : 1.65,
        fontSize: compact ? "12px" : "14px",
      }}
    >
      {segments.map((seg, i) =>
        i % 2 === 1 ? (
          <strong key={i} style={{ color: "var(--ua-navy)", fontWeight: 700 }}>
            {seg}
          </strong>
        ) : (
          <span key={i} style={compact ? { color: "var(--ua-muted)" } : undefined}>
            {seg}
          </span>
        ),
      )}
    </div>
  );
}
